import { createSlice } from "@reduxjs/toolkit";
import { UserSignIn, LogOut } from "../Actions/authAction";
import customFailAlert from "../../Alerts/customFailAlert";
import { secureTokenManager } from "../../utils/secureTokenManager";

const initialState = {
  token: "",
  refreshToken: "",
  status: "",
  message: "",
  loading: false,
  error: "",
  userDetails: {},
  userInfo: {},
  lastActivity: Date.now(),
};

const authReducer = createSlice({
  name: "user",
  initialState,
  reducers: {
    setAuthDetails: (state, action) => {
      state.token = action.payload.token;
      state.email = action.payload.email;
      state.refreshToken = action.payload.refreshToken;
      
      // Use secure token manager instead of localStorage
      secureTokenManager.setTokens(action.payload.token, action.payload.refreshToken);
    },
    addToken: (state) => {
      // Get tokens from secure storage instead of localStorage
      state.token = secureTokenManager.getAccessToken();
      state.refreshToken = secureTokenManager.getRefreshToken();
    },
    clearAuthDetails: (state) => {
      state.token = "";
      state.email = "";
      state.refreshToken = "";
      state.userDetails = {};
      state.userInfo = {};
      
      // Clear secure token storage
      secureTokenManager.clearTokens();
    },
    userLogout: (state) => {
      state.token = "";
      state.refreshToken = "";
      state.email = "";
      state.userDetails = {};
      state.userInfo = {};
      
      // Clear secure token storage
      secureTokenManager.clearTokens();
    }
  },
  extraReducers: {
    [UserSignIn.pending]: (state) => {
      state.loading = true;
    },
    [UserSignIn.fulfilled]: (
      state,
      {
        payload: {
          responseData: { data, message, statusCode },
          requestBody: { portal },
        },
      }
    ) => {
      state.loading = false;
      if (statusCode === 201 && data) {
        const { accessToken, refreshToken } = data;
        state.token = accessToken;
        state.refreshToken = refreshToken;
        
        // Use secure token manager instead of localStorage
        secureTokenManager.setTokens(accessToken, refreshToken);
        
        state.userInfo = { ...data, portal };
        state.message = message;
        state.status = "SUCCESS";
      } else {
        // customFailAlert(message);
        state.error = message;
        state.status = "FAILED";
      }
    },
    [UserSignIn.rejected]: (state) => {
      state.loading = false;
    },
    [LogOut.fulfilled]: (state) => {
      state.token = "";
      state.refreshToken = "";
      state.user = null;
      state.loading = false;
      
      // Clear secure token storage
      secureTokenManager.clearTokens();
    }
  },
});

export const { addToken, logout, setAuthDetails, clearAuthDetails, userLogout } = authReducer.actions;
export default authReducer.reducer;
